import { Component, OnInit ,Input, Output,EventEmitter} from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { AccountService,InstoreService } from '@app/_services'; 
import { first } from 'rxjs/operators';
import { UntypedFormGroup,UntypedFormBuilder } from '@angular/forms';
import { ToastrService,IndividualConfig } from 'ngx-toastr';
import * as moment from 'moment';                                                  
import {Sort} from '@angular/material/sort';
import { InstorelistComponent } from '@app/module/instorelist/instorelist/instorelist.component';
import { ConfirmDialogService } from '@app/module/confirm-dialog/confirm-dialog/confirm-dialog.service';  

import { DataService } from '@app/_services';

@Component({
  selector: 'app-modifyinstore',
  templateUrl: './modifyinstore.component.html',
  styleUrls: ['./modifyinstore.component.css']
})
export class ModifyinstoreComponent implements OnInit {
  
  @Input() startDateLabel: string;
  @Input() endDateLabel: string;

  @Input() startDateInput;
  @Input() endDateInput;
  @Output() StartEndDatesOutput = new EventEmitter();

  @Input() selected_Instore_Lists:any=[];
  filtered_Instore_Lists:any=[];
  form: UntypedFormGroup;
  options: IndividualConfig;
  message:string;
  private format = 'YYYY-MM-DD';

  searchTerm:string="";
  
  selected_region_id;
  selected_showroom_id;

  user_role_id: number=0;
  isDiscontinue:boolean = false;


  isAllChecked:boolean;
  isShowBtn:boolean;
  constructor(private instoreService: InstoreService, private instoreLists :InstorelistComponent,private confirmDialogService: ConfirmDialogService ,
    private formBuilder: UntypedFormBuilder,private modalService: NgbModal,private toastr: ToastrService, private accountService: AccountService,private dataService:DataService) {
    this.isAllChecked = false;
    this.isShowBtn = false;
    this.options = this.toastr.toastrConfig;
    this.options.timeOut = 1000;
   }
  page = 1;
  pageSize = 10;
  AssetsDataLists;
  CreativeDataLists;
  f_locationLists;
  f_FloorLists;
  VendorDataLists;
  isLoading = false;
  todayDate:Date = new Date();


  checked_InstoreLists=[];
  selectedAssetIds = [];
  selectedCreativeIds =[];
  selectedVendorIds =[];

  isUpdate;
  ngOnInit(): void {
    this.isUpdate = this.instoreService.getIsUpdateorModify();
    this.selected_Instore_Lists = JSON.parse(localStorage.getItem('lists')).slice();


    this.reloadAssetsLists()
    this.reloadCreativeLists()
    this.reloadVendorLists()

    this.selected_region_id = this.instoreService.getRegionID();
    this.selected_showroom_id = this.instoreService.getShowroomID();


    this.dataService.getAssetDataLists().subscribe(assetIDs => {
      this.selectedAssetIds = assetIDs;
      this.filterITable();
    })
    this.dataService.getCreativeDataLists().subscribe(creativeIDs => {
      this.selectedCreativeIds = creativeIDs;
      this.filterITable();
    })
    this.dataService.getVendorDataLists().subscribe(vendorIds => {
      this.selectedVendorIds = vendorIds;
      this.filterITable();
    })
    this.dataService.getSearchText().subscribe(searchText => {
      this.searchTerm = searchText;
      console.log(this.searchTerm)
    })




    this.form = this.formBuilder.group({
      instore_ids:'',
      particulars: [''], //m
      region_id: [''], //m
      showroom_id: [''], //m
      floor_id: [''], //m
      location_id: [''], //m
      asset_type_id: [''], //m
      creative_id: [''], //m
      vendor_id: [''], //m
      name : [''], //m
      size_w: [''], //m
      size_h: [''], //m
      square_feet:[''],
      install_date: [''], //m
      expiry_date: [''], //m
      image: [''],  });

      this.onFilterShowroomChange();

      var userdata = localStorage.getItem('userInformation');
      var parsedUserData = JSON.parse(userdata);
      if(parsedUserData) {
        this.user_role_id = parsedUserData.role_id;
        if(this.user_role_id==1 || this.user_role_id ==2){
          this.isDiscontinue = true;
        }else{
          this.isDiscontinue = false
        }
      }

  }

  get f() { return this.form.controls; }




  CheckAllOptions(){
      this.checkisAllSelected();
      for (let i = 0; i < this.filtered_Instore_Lists.length; i++) {
          if(this.isAllChecked){
              this.filtered_Instore_Lists[i].isUpdateModify = false;
          }else{
              this.filtered_Instore_Lists[i].isUpdateModify = true;
          }
      }
      this.checkisAllSelected();
      this.isShowButton();
  }


  settoUdpateModify(id){
    for (let i = 0; i < this.filtered_Instore_Lists.length; i++) {
      if(this.filtered_Instore_Lists[i].id===id){
        if(this.filtered_Instore_Lists[i].isUpdateModify){
          this.filtered_Instore_Lists[i].isUpdateModify = false;
        }else{
          this.filtered_Instore_Lists[i].isUpdateModify = true;
        }
      }
    }
    this.checkisAllSelected();
    this.isShowButton();
  }
  omit_special_char(event) {   
    var k;  
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
  }

  onInstoreubmit(){

    
    this.form.controls.instore_ids.setValue(this.checked_InstoreLists.toString());
    if(this.f.install_date.value !=""){
      this.form.get("install_date").setValue(moment(this.f.install_date.value).format(this.format)); //Working
    }
    if(this.f.expiry_date.value !=""){
      this.form.get("expiry_date").setValue(moment(this.f.expiry_date.value).format(this.format)); //Working
    }

    if(this.f.install_date.value != "" && this.f.expiry_date.value === ""){
      this.toastr.warning("Please select Expiry Date", "info"); 
      return;
    }
    if(this.f.install_date.value === "" && this.f.expiry_date.value  != ""){
      this.toastr.warning("Please select Installation Date", "info");  
      return;
    }
    if(this.f.floor_id.value != "" && this.f.location_id.value  === ""){
      this.toastr.warning("Please select Location for the selected Floor", "info");  
      return;
    }
    // console.log(this.f.floor_id.value+"==="+this.f.location_id.value) 
    // console.log("==="+JSON.stringify(this.form.value))


    const formDataNew = new FormData();   
    formDataNew.append('instore_ids', this.form.value.instore_ids);
    formDataNew.append('particulars',  this.form.value.particulars);
    formDataNew.append('region_id',  this.form.value.region_id);
    formDataNew.append('showroom_id', ""+this.selected_showroom_id);
    formDataNew.append('floor_id',  this.form.value.floor_id);
    formDataNew.append('location_id',  this.form.value.location_id);
    formDataNew.append('asset_type_id',  this.form.value.asset_type_id);
    formDataNew.append('creative_id',  this.form.value.creative_id);
    formDataNew.append('vendor_id', this.form.value.vendor_id);


    formDataNew.append('name',  this.form.value.name);
    formDataNew.append('size_w',  this.form.value.size_w);
    formDataNew.append('size_h', this.form.value.size_h);
    formDataNew.append('square_feet',  this.form.value.square_feet);
    formDataNew.append('install_date',  this.form.value.install_date);
    formDataNew.append('expiry_date', this.form.value.expiry_date);
    formDataNew.append('image', this.form.get('image').value);
    // for (var pair of formDataNew.entries()) {
    //   console.log(pair[0]+ ', ' + pair[1]); 
    // }
    if(this.isUpdate){
      this.instoreService.instoreBulkUpdate(formDataNew)
      .pipe(first())
        .subscribe(
        (response) => {
          this.isLoading = false;
          console.log("=response=="+JSON.stringify(response));
          this.toastr.warning("Record has been modified successfully", "Success"); 
          this.modalService.dismissAll();
          this.instoreLists.viewModule();
        },
        (error) => {     
          this.isLoading = false;                               
        }
      );
      
    }else{
      this.instoreService.instoreBulkModify(formDataNew)
      .pipe(first())
        .subscribe(
        (response) => {
          this.isLoading = false;
          console.log("=response=="+JSON.stringify(response));
          this.toastr.warning("Record has been modified successfully", "Success"); 
          this.modalService.dismissAll();
          this.instoreLists.viewModule();
        },
        (error) => {     
          this.isLoading = false;                               
        }
      );
    }
  
  }

  
  closeResult :string
  open(content) {

    this.checked_InstoreLists=[];
    for (let i = 0; i < this.filtered_Instore_Lists.length; i++) {
        if(this.filtered_Instore_Lists[i].isUpdateModify){
          this.checked_InstoreLists.push(this.filtered_Instore_Lists[i].id);
        }
    }
   

    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'lg'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  onWidthChange(){
    if(this.form.controls.size_w.value !=null ||this.form.controls.size_w.value !=''){
      if(this.form.controls.size_h.value !=null ||this.form.controls.size_h.value !=''){
        var squarefeet = this.form.controls.size_h.value *this.form.controls.size_h.value;
        this.form.controls.square_feet.setValue(squarefeet);
      }
    }
  }
  onHeightChange(){
    if(this.form.controls.size_h.value !=null ||this.form.controls.size_h.value!=''){
      if(this.form.controls.size_w.value !=null ||this.form.controls.size_w.value!=''){
        var squarefeet = this.form.controls.size_h.value *this.form.controls.size_h.value;
        this.form.controls.square_feet.setValue(squarefeet);
      }
    }
  }

  sortData(sort: Sort) {
    const data = this.filtered_Instore_Lists.slice();
    if (!sort.active || sort.direction == '') {
      this.filtered_Instore_Lists = data;
      return;
    }
    
    this.filtered_Instore_Lists = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'name': return this.accountService.compare(a.name, b.name, isAsc);
        case 'address': return this.accountService.compare(a.address, b.address, isAsc);
        case 'vendorName': return this.accountService.compare(a.vendorName, b.vendorName, isAsc);
        case 'assetTypeName': return this.accountService.compare(a.assetTypeName, b.assetTypeName, isAsc);
        case 'creativeName': return this.accountService.compare(a.creativeName, b.creativeName, isAsc);
        case 'cost': return this.accountService.compare(a.cost, b.cost, isAsc);
        case 'regionName': return this.accountService.compare(a.regionName, b.regionName, isAsc);
        case 'showroomName': return this.accountService.compare(a.showroomName, b.showroomName, isAsc);

      }
    });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  checkisAllSelected(){
      this.isAllChecked = this.filtered_Instore_Lists.every(function(item:any) {
        return item.isUpdateModify == true;
      })   
  }
  isShowButton(){
      var count_SelectedInstore= [];
      for (let i = 0; i < this.filtered_Instore_Lists.length; i++) {
          if(this.filtered_Instore_Lists[i].isUpdateModify){
            count_SelectedInstore.push(this.filtered_Instore_Lists[i]);
            // this.isShowBtn =true;
            // break;
          }else{
            // this.isShowBtn =false;
          }
      }
      if(count_SelectedInstore.length>1){
        this.isShowBtn =true;
      }else{
        this.isShowBtn =false;
      }
  }
  discontinue(){


    this.checked_InstoreLists=[];
    for (let i = 0; i < this.filtered_Instore_Lists.length; i++) {
        if(this.filtered_Instore_Lists[i].isUpdateModify){
          this.checked_InstoreLists.push(this.filtered_Instore_Lists[i].id);
        }
    }
      this.confirmDialogService.confirmThis('Are you sure you want to discontinue ?', () =>  {
      this.isLoading = true;
      this.instoreService.bulkinstoreDiscontinue(this.checked_InstoreLists,1)
      .pipe(first())
        .subscribe(
        (response) => {
          this.isLoading = false;
          this.toastr.warning("Record has been updated successfully", "Success");    
          this.modalService.dismissAll();
          this.instoreLists.viewModule(); 
        },
      (error) => {     
        this.isLoading = false;                 
        this.toastr.warning("Sorry, something went wrong Please try again", "Warning");              
      }
      );
      }, () => {
        
      }); 

  }
  reloadAssetsLists(){
    this.accountService.getAssetsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.AssetsDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadCreativeLists(){
    this.accountService.getCreativeLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.CreativeDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  onFilterShowroomChange(){
    this.instoreService.getFloorLists(this.selected_showroom_id)
      .pipe(first())
        .subscribe(
        (response) => {
          this.isLoading = false;
          this.f_FloorLists = response.result;         
        },
      (error) => {     
        this.isLoading = false;                               
      }
      );
   }
  getFloorLocationLists(floorID){
    this.form.patchValue({
      location_id: ''
      });
    this.accountService.getFloorLocationLists(this.selected_region_id, this.selected_showroom_id, floorID)
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.f_locationLists = response.result;  
        console.log("-f_locationLists--"+JSON.stringify(this.f_locationLists))      
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }



  
   reloadVendorLists(){
    this.accountService.getVendorLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.VendorDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  imageSrc: string;

  onFileChange(event) {
  
    const max_size = 5242880;
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];


    const reader = new FileReader();
    const file:File = event.target.files[0];

    if (file.size > max_size) {
        alert("Image Size should not exceed more than 5 MB")
        return false;
    }
    
    
    if(event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        /*
        this.form.patchValue({
          image: reader.result
        });
        */
       this.form.get('image').setValue(event.target.files[0]);
       console.log("onFileChange "+event.target.files[0]);
      };  
   
    }
  }

  startDateClicked() {
    this.StartEndDatesOutput.emit(this.getDates());
  }

  endDateClicked() {
    if (this.form.controls['install_date'].value) {
      let eventStartTime = new Date(this.form.controls['install_date'].value);
      let eventEndTime = new Date(this.form.controls['expiry_date'].value);
      this.StartEndDatesOutput.emit(this.getDates());
    } else {
      console.log('Please select the start date');
      this.form.controls['expiry_date'].setValue('');
    }
  }
  public splitNumber(value: number):string {
    if(value!=null){
      if(value == 0){
        return 0+"";
      }
      return Math.round(value * 100) / 100+"'";
    }
  }
  getDates() {
    let startEndDates = {
      'install_date': this.form.controls['install_date'].value,
      'expiry_date': this.form.controls['expiry_date'].value
    };
    return startEndDates;
  }

  filterITable() {
    // console.log("instore ids - - "+this.selectedAssetIds);
    // console.log("creative ids - - "+this.selectedCreativeIds);
    // console.log("vendor ids - - "+this.selectedVendorIds);
    this.filtered_Instore_Lists=[];
    if(this.selectedAssetIds.length>0  &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
      this.filtered_Instore_Lists = [
         ...this.selected_Instore_Lists.filter(x => this.selectedAssetIds.includes(x.asset_type_id))
    ];
  }else if(this.selectedAssetIds.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
    console.log("creative ids - - "+this.selectedCreativeIds);
      this.filtered_Instore_Lists = [
          ...this.selected_Instore_Lists.filter(x => this.selectedCreativeIds.includes(x.creative_id))
    ];
  }else if(this.selectedAssetIds.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
      this.filtered_Instore_Lists = [
          ...this.selected_Instore_Lists.filter(x => this.selectedVendorIds.includes(x.vendor_id))
    ];
  }


 else if(this.selectedAssetIds.length>0  &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length==0){
  this.filtered_Instore_Lists = [
    ...this.selected_Instore_Lists.filter(x => this.selectedAssetIds.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id))
  ];
  }else if(this.selectedAssetIds.length>0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length>0){
    this.filtered_Instore_Lists = [
      ...this.selected_Instore_Lists.filter(x => this.selectedAssetIds.includes(x.asset_type_id) && this.selectedVendorIds.includes(x.vendor_id))
    ];
  }else if(this.selectedAssetIds.length==0 &&  this.selectedCreativeIds.length>0 &&  this.selectedVendorIds.length>0){
    this.filtered_Instore_Lists = [
      ...this.selected_Instore_Lists.filter(x => this.selectedCreativeIds.includes(x.creative_id) && this.selectedVendorIds.includes(x.vendor_id))
    ];
  }



  else if(this.selectedAssetIds.length==0 &&  this.selectedCreativeIds.length==0 &&  this.selectedVendorIds.length==0){
      this.filtered_Instore_Lists = [...this.selected_Instore_Lists];
  }else{
      this.filtered_Instore_Lists = [
        ...this.selected_Instore_Lists.filter(x => this.selectedAssetIds.includes(x.asset_type_id) && this.selectedCreativeIds.includes(x.creative_id)&& this.selectedVendorIds.includes(x.vendor_id))
      ];
  }
  console.log("---"+this.filtered_Instore_Lists.length)
  }
}